import { render, staticRenderFns } from "./leftBox-tj.vue?vue&type=template&id=7f905326&scoped=true"
import script from "./leftBox-tj.vue?vue&type=script&lang=js"
export * from "./leftBox-tj.vue?vue&type=script&lang=js"
import style0 from "./leftBox-tj.vue?vue&type=style&index=0&id=7f905326&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f905326",
  null
  
)

export default component.exports